// redux/lawyerSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  name: '',                 // Full Client Name
  dob: '',                  // Date of Birth
  phone: '',                // Phone Number
  profilePhotoUrl: '',      // URL for Profile Photo
  city: '',                 // City
  zipCode: '',              // Zip Code
  latitude: '',
  longitude: '',
  state: ''
};

const clientSlice = createSlice({
  name: 'client',
  initialState,
  reducers: {
    updateClientInfo: (state, action) => {
      return { ...state, ...action.payload };
    },
    setProfilePhotoUrl: (state, action) => {
      state.profilePhotoUrl = action.payload;
    },
    resetClientInfo: () => initialState, // Action to reset the state
  },
});

export const { updateClientInfo, setProfilePhotoUrl, resetClientInfo } = clientSlice.actions;
export default clientSlice.reducer;
